import React from 'react';
import { Home, Crown } from 'lucide-react';

// Choose where capped cells go: a mating nuc or straight into a hive
export const TransferTargetToggle = ({ value, onChange, testPrefix }) => (
  <div className="grid grid-cols-2 gap-1 rounded-xl bg-stone-100 p-1" role="tablist">
    {[{ id: 'nuc', label: 'Mating NUC', Icon: Home }, { id: 'hive', label: 'Queenless hive / split', Icon: Crown }].map(({ id, label, Icon }) => (
      <button key={id} role="tab" aria-selected={value === id} onClick={() => onChange(id)} data-testid={`${testPrefix}-target-${id}`}
        className={`flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-sm font-medium transition-colors ${value === id ? 'bg-white text-indigo-700 shadow-sm' : 'text-stone-600 hover:text-stone-800'}`}>
        <Icon className="h-4 w-4" />{label}
      </button>
    ))}
  </div>
);

export default TransferTargetToggle;
